import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function IlDnaDellaConsulenza() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="il-dna-della-consulenza" className="dark bg-background text-foreground py-24 md:py-40 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 select-none pointer-events-none z-0" aria-hidden="true">
        <span className="text-[12rem] md:text-[25rem] font-bold text-foreground/5 font-sans leading-none tracking-tighter">
          10+
        </span>
      </div>

      {}
      <div ref={ref} className={cn("container mx-auto px-4 relative z-10 max-w-[800px] flex flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-8 text-foreground">Consulenza Tecnica&nbsp;</h2>

        <div className="space-y-6 text-lg md:text-xl text-muted-foreground leading-relaxed font-light">
          <p>B-Tech nasce da oltre un decennio di esperienza tecnica&nbsp;<span style={{
            color: 'rgb(148, 163, 184)',
            letterSpacing: '-0.32px'
          }}>nell’analisi, integrazione e ottimizzazione delle tecnologie&nbsp;</span><span style={{
            color: 'rgb(148, 163, 184)',
            letterSpacing: '-0.32px'
          }}>utilizzate negli ambienti di lavoro aziendali, anche in contesti&nbsp;</span><span style={{
            color: 'rgb(148, 163, 184)',
            letterSpacing: '-0.32px'
          }}>enterprise e operativi complessi.</span></p>
          
        </div>

        {}
        <div className="mt-16 md:mt-24 relative">
          <div className="w-16 h-1 bg-primary/50 mx-auto mb-6 rounded-full" />
          <span className="font-serif text-4xl md:text-5xl italic text-foreground tracking-wide opacity-90">
            B-Tech
          </span>
          
        </div>
      </div>
    </section>;
}